@if (specialties?.length > 0) {
  @for (specialty of specialties; track specialty) {
    <span
      class="indicator-pill fw-normal me-1 px-2"
      [class.indicator-pill-green]="isCurated(specialty)"
      [class.indicator-pill-gray]="!isCurated(specialty)"
      [title]="isCurated(specialty) ? 'Curated Specialty' : ''"
      >
      {{ specialty }}
    </span>
  }
} @else if (showBlank) {
  <app-blank-value-dash />
}
